module.exports = __webpack_public_path__ + "img/CB34-On-Off-1.981379c8.gif";